/* Squish Deli checkout nudge (sections/sd-checkout-nudge.liquid). CONTENT role.
   Catches presses on any Checkout button (name="checkout"). If the cart's plate pieces sit one plate step below a
   cheaper per-piece price (3 / 5 / 8), it opens #sd-nudge with quick-add pieces and the real numbers from /cart.js.
   Once per session; "No thanks, check out" and the main button both go to /checkout. QA: ?sd_nudge=1 forces it. */

const SEEN_KEY = 'sd-nudge-seen';
const dlg = /** @type {HTMLDialogElement | null} */ (document.getElementById('sd-nudge'));

if (dlg && !dlg.dataset.sdReady) {
  dlg.dataset.sdReady = 'true';
  init(dlg);
}

function money(cents) {
  const v = cents / 100;
  return '$' + (Number.isInteger(v) ? String(v) : v.toFixed(2));
}

function seen(set) {
  try {
    if (set) window.sessionStorage.setItem(SEEN_KEY, '1');
    return window.sessionStorage.getItem(SEEN_KEY) === '1';
  } catch {
    return false;
  }
}

/** @param {HTMLDialogElement} dlg */
function init(dlg) {
  const plateHandles = new Set((dlg.dataset.plateHandles || '').split(',').filter(Boolean));
  const suggest = (dlg.dataset.suggest || '').split(',').map((h) => h.trim()).filter(Boolean);
  const tiers = JSON.parse(dlg.dataset.tiers || '[]');
  const single = Number(dlg.dataset.single || 1800);
  const freeShip = Number(dlg.dataset.freeShip || 3500);
  const qa = new URL(window.location.href).searchParams.get('sd_nudge') === '1';
  const title = dlg.querySelector('[data-sd-nudge-title]');
  const line = dlg.querySelector('[data-sd-nudge-line]');
  const sub = dlg.querySelector('[data-sd-nudge-sub]');
  const picks = dlg.querySelector('[data-sd-nudge-picks]');
  const go = dlg.querySelector('[data-sd-nudge-go]');
  const baseTitle = title ? title.textContent : '';
  let added = false;
  /** @type {Promise<any[]> | null} */
  let productsPromise = null;

  async function cart() {
    return (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
  }

  function plateCount(c) {
    return c.items.filter((i) => plateHandles.has(i.handle)).reduce((n, i) => n + i.quantity, 0);
  }

  function tierFor(n) {
    let t = null;
    for (const x of tiers) if (n >= x.n) t = x;
    return t;
  }

  function nextTier(n) {
    return tiers.find((x) => n < x.n) || null;
  }

  function loadProducts() {
    if (!productsPromise) {
      productsPromise = Promise.all(
        suggest.map((h) =>
          fetch(`/products/${h}.js`)
            .then((r) => (r.ok ? r.json() : null))
            .catch(() => null)
        )
      ).then((list) => list.filter((p) => p && p.available));
    }
    return productsPromise;
  }

  async function render() {
    const c = await cart();
    const n = plateCount(c);
    const next = nextTier(n);
    const other = c.items.filter((i) => !plateHandles.has(i.handle)).reduce((s, i) => s + i.final_line_price, 0);
    if (!next) {
      const t = tierFor(n);
      if (title) title.textContent = 'Plate deal unlocked.';
      if (line) line.innerHTML = t ? `Every squish on your plate is now <strong>${money(t.each)}</strong> (${t.name}).` : '';
      if (sub) sub.textContent = `${n} pieces · ${money(c.total_price)} · ${c.total_price >= freeShip ? 'ships free' : 'shipping at checkout'}`;
      if (go) go.textContent = 'Check out';
      return { n, next };
    }
    const need = next.n - n;
    const projected = next.n * next.each + other;
    if (title) title.textContent = baseTitle;
    if (line) line.innerHTML = `Add <strong>${need} more</strong> and every squish on your plate drops to <strong>${money(next.each)}</strong> (${next.name}).`;
    const now = tierFor(n);
    if (sub) sub.textContent = `Now ${money(now ? now.each : single)} each · ${next.n} for ${money(next.n * next.each)}${projected >= freeShip ? ', shipped free' : ''}`;
    if (go) go.textContent = added ? 'Check out' : 'Check out as is';
    return { n, next };
  }

  async function renderPicks() {
    if (!picks) return;
    const products = await loadProducts();
    // Lead with pieces that are not on the plate yet; fall back to the full list if everything is already in the cart
    const inCart = new Set((await cart()).items.map((i) => i.handle));
    const fresh = products.filter((p) => !inCart.has(p.handle));
    picks.innerHTML = '';
    for (const p of (fresh.length >= 3 ? fresh : products).slice(0, 6)) {
      const v = p.variants.find((x) => x.available) || p.variants[0];
      const img = (v.featured_image && v.featured_image.src) || p.featured_image || '';
      const li = document.createElement('li');
      li.className = 'sd-nudge__pick';
      li.innerHTML = `<img src="${img}${img.includes('?') ? '&' : '?'}width=300" alt="" loading="lazy" width="300" height="300">
        <div class="sd-nudge__pick-body"><span class="sd-nudge__pick-name"></span>
        <button type="button" class="sd-nudge__add">+ Add</button></div>`;
      li.querySelector('.sd-nudge__pick-name').textContent = p.title.replace(/^The /, '');
      const btn = li.querySelector('button');
      btn.addEventListener('click', async () => {
        btn.setAttribute('aria-busy', 'true');
        try {
          const r = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] }),
          });
          if (r.ok) {
            added = true;
            btn.classList.add('is-added');
            btn.textContent = 'Added +1';
            await render();
          }
        } finally {
          btn.removeAttribute('aria-busy');
        }
      });
      picks.appendChild(li);
    }
  }

  function goCheckout(event) {
    if (event) event.preventDefault();
    seen(true);
    window.location.href = '/checkout';
  }

  function close() {
    seen(true);
    try {
      dlg.close();
    } catch {
      dlg.removeAttribute('open');
    }
    if (added) window.location.reload();
  }

  async function open() {
    const state = await render();
    if (!qa && (!state.next || state.n === 0)) return false;
    await renderPicks();
    try {
      dlg.showModal();
    } catch {
      dlg.setAttribute('open', '');
    }
    seen(true);
    return true;
  }

  dlg.querySelector('[data-sd-nudge-close]')?.addEventListener('click', close);
  dlg.addEventListener('cancel', (e) => {
    e.preventDefault();
    close();
  });
  dlg.addEventListener('click', (e) => {
    if (e.target === dlg) close();
  });
  dlg.querySelector('[data-sd-nudge-skip]')?.addEventListener('click', goCheckout);
  go?.addEventListener('click', goCheckout);

  document.addEventListener(
    'click',
    async (event) => {
      const t = event.target instanceof Element ? event.target.closest('[name="checkout"], a[href="/checkout"]') : null;
      if (!t || dlg.contains(t) || dlg.open) return;
      if (seen() && !qa) return;
      event.preventDefault();
      event.stopPropagation();
      let shown = false;
      try {
        shown = await open();
      } catch {
        shown = false;
      }
      if (!shown) goCheckout();
    },
    true
  );

  if (qa && new URL(window.location.href).searchParams.get('sd_nudge_open') === '1') open();
}
